var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaqIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_401_2950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.49996 15.5833C12.412 15.5833 15.5833 12.412 15.5833 8.5C15.5833 4.58799 12.412 1.41667 8.49996 1.41667C4.58794 1.41667 1.41663 4.58799 1.41663 8.5C1.41663 12.412 4.58794 15.5833 8.49996 15.5833Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.43872 6.37501C6.60525 5.9016 6.93395 5.50242 7.36661 5.24814C7.79926 4.99387 8.30794 4.90092 8.80255 4.98576C9.29717 5.0706 9.7458 5.32775 10.069 5.71167C10.3922 6.09559 10.5691 6.5815 10.5683 7.08334C10.5683 8.50001 8.4433 9.20834 8.4433 9.20834",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 12.0417H8.50708",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_401_2950"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqIcon);
export default __webpack_public_path__ + "static/media/faq-icon.dbddfb754d068f2378b89a61c50b3f96.svg";
export { ForwardRef as ReactComponent };